/* ==========================================================================
   LUMARVA ORGANIC LIGHTING - STANDARD SHOPIFY CHECKOUT & CART JS
   ========================================================================== */

  // Mobile Navigation Drawer Toggle Handler (Solution A & Global Window Binding)
  window.openMobileNav = function() {
    const mobileDrawer = document.getElementById('MobileNavDrawer');
    const mobileBackdrop = document.getElementById('MobileNavBackdrop');
    if (mobileDrawer) mobileDrawer.style.transform = 'translateX(0)';
    if (mobileBackdrop) {
      mobileBackdrop.style.opacity = '1';
      mobileBackdrop.style.visibility = 'visible';
    }
    document.body.style.overflow = 'hidden';
  };

  window.closeMobileNav = function() {
    const mobileDrawer = document.getElementById('MobileNavDrawer');
    const mobileBackdrop = document.getElementById('MobileNavBackdrop');
    if (mobileDrawer) mobileDrawer.style.transform = 'translateX(-100%)';
    if (mobileBackdrop) {
      mobileBackdrop.style.opacity = '0';
      mobileBackdrop.style.visibility = 'hidden';
    }
    document.body.style.overflow = '';
  };

  const mobileToggleBtn = document.querySelector('[data-mobile-toggle], .header__mobile-toggle');
  const mobileCloseBtn = document.getElementById('MobileNavClose');
  const mobileBackdrop = document.getElementById('MobileNavBackdrop');

  if (mobileToggleBtn) mobileToggleBtn.addEventListener('click', window.openMobileNav);
  if (mobileCloseBtn) mobileCloseBtn.addEventListener('click', window.closeMobileNav);
  if (mobileBackdrop) mobileBackdrop.addEventListener('click', window.closeMobileNav);

  document.querySelectorAll('.mobile-menu-link').forEach(link => {
    link.addEventListener('click', window.closeMobileNav);
  });

  // FAQ Accordion Global Handler
  window.toggleFaqItem = function(btn) {
    if (!btn) return;
    const answer = btn.nextElementSibling;
    const icon = btn.querySelector('.faq-item__icon');
    if (!answer) return;

    const isExpanded = btn.getAttribute('aria-expanded') === 'true';
    if (isExpanded) {
      btn.setAttribute('aria-expanded', 'false');
      answer.style.display = 'none';
      if (icon) icon.textContent = '+';
    } else {
      btn.setAttribute('aria-expanded', 'true');
      answer.style.display = 'block';
      if (icon) icon.textContent = '−';
    }
  };

  // Elements
  const cartToggles = document.querySelectorAll('[data-cart-toggle], .header__cart-btn, #cartDrawerBtn');
  const cartDrawer = document.getElementById('CartDrawer');
  const cartClose = document.querySelector('.cart-drawer__close');
  const cartOverlay = document.querySelector('.cart-drawer__overlay');
  const cartBadges = document.querySelectorAll('.cart-count-val');
  const cartBody = document.getElementById('CartDrawerBody');
  const cartFooter = document.getElementById('CartDrawerFooter');
  const cartSubtotal = document.querySelector('.cart-subtotal-val');

  window.openCart = function(e) {
    if (e && e.preventDefault) e.preventDefault();
    const cDrawer = document.getElementById('CartDrawer');
    if (!cDrawer) return;
    cDrawer.classList.add('active');
    cDrawer.style.visibility = 'visible';
    cDrawer.style.pointerEvents = 'auto';
    const container = cDrawer.querySelector('.cart-drawer__container');
    if (container) container.style.transform = 'translateX(0)';
    const overlay = cDrawer.querySelector('.cart-drawer__overlay');
    if (overlay) overlay.style.opacity = '1';
    document.body.style.overflow = 'hidden';
    if (typeof window.fetchCart === 'function') {
      window.fetchCart();
    }
  };

  window.closeCart = function() {
    const cDrawer = document.getElementById('CartDrawer');
    if (!cDrawer) return;
    cDrawer.classList.remove('active');
    cDrawer.style.visibility = 'hidden';
    cDrawer.style.pointerEvents = 'none';
    const container = cDrawer.querySelector('.cart-drawer__container');
    if (container) container.style.transform = 'translateX(100%)';
    const overlay = cDrawer.querySelector('.cart-drawer__overlay');
    if (overlay) overlay.style.opacity = '0';
    document.body.style.overflow = '';
  };

  cartToggles.forEach(btn => btn.addEventListener('click', window.openCart));
  if (cartClose) cartClose.addEventListener('click', window.closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', window.closeCart);

  // Global Cart State Holder for Optimistic Instant UI Updates
  let lastCartState = null;

  // Helper to format money
  const formatMoney = (cents) => {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return 'PKR ' + (cents / 100).toLocaleString();
  };

  // ⚡ 0ms Lightning-Fast Optimistic Add to Cart
  window.optimisticAddToCart = function(itemData) {
    if (!lastCartState) {
      lastCartState = { items: [], item_count: 0, total_price: 0 };
    }
    lastCartState.items = lastCartState.items || [];

    const addQty = Math.max(1, parseInt(itemData.quantity, 10) || 1);
    const unitPrice = itemData.price || 0;
    const existingIdx = lastCartState.items.findIndex(i => String(i.id) === String(itemData.id));

    if (existingIdx !== -1) {
      lastCartState.items[existingIdx].quantity += addQty;
      lastCartState.items[existingIdx].final_line_price = unitPrice * lastCartState.items[existingIdx].quantity;
    } else {
      const newItem = {
        key: 'opt_' + Date.now(),
        id: itemData.id,
        title: itemData.title || itemData.product_title || 'LUMARVA Lamp',
        product_title: itemData.product_title || itemData.title || 'LUMARVA Lamp',
        image: itemData.image || '',
        variant_title: itemData.variant_title || '',
        price: unitPrice,
        final_line_price: unitPrice * addQty,
        quantity: addQty,
        properties: itemData.properties || {}
      };
      lastCartState.items.unshift(newItem);
    }

    lastCartState.item_count = lastCartState.items.reduce((sum, i) => sum + i.quantity, 0);
    lastCartState.total_price = lastCartState.items.reduce((sum, i) => sum + (i.final_line_price || (i.price * i.quantity) || 0), 0);

    // Instant 0ms Render & Open
    renderCartDrawer(lastCartState);
    window.openCart();
  };

  // Fetch Cart from Shopify API
  window.fetchCart = async function() {
    try {
      const res = await fetch('/cart.js');
      if (!res.ok) return;
      lastCartState = await res.json();
      if (lastCartState && lastCartState.items) {
        lastCartState.items.forEach(item => {
          const t = ((item.title || '') + ' ' + (item.product_title || '')).toLowerCase();
          const isDark = (item.variant_title && item.variant_title.toLowerCase().includes('dark')) ||
                         (item.properties && item.properties['Leg Finish'] && item.properties['Leg Finish'].toLowerCase().includes('dark'));
          const isRgb = (item.variant_title && (item.variant_title.includes('LED') || item.variant_title.toLowerCase().includes('rgb'))) ||
                        (item.properties && item.properties['Lighting Option'] && item.properties['Lighting Option'].toLowerCase().includes('rgb'));

          if (t.includes('aspen')) {
            const isPro = (item.variant_title && (item.variant_title.includes('Aspen Plus') || item.variant_title.includes('Aspen Pro'))) ||
                          (item.properties && (item.properties['Size'] === 'Aspen Plus' || item.properties['Size'] === 'Aspen Pro' || item.properties['Model Size'] === 'Aspen Plus' || item.properties['Model Size'] === 'Aspen Pro')) ||
                          (item.title && (item.title.includes('Aspen Plus') || item.title.includes('Aspen Pro')));
            let unitPrice = isPro ? 2600000 : 1760000;
            if (isPro) {
              if (isDark && isRgb) unitPrice = 2840000;
              else if (isRgb) unitPrice = 2790000;
              else if (isDark) unitPrice = 2650000;
            } else {
              if (isDark && isRgb) unitPrice = 2000000;
              else if (isRgb) unitPrice = 1950000;
              else if (isDark) unitPrice = 1810000;
            }
            item.price = unitPrice;
            item.final_line_price = unitPrice * item.quantity;
          } else if (t.includes('nova')) {
            let unitPrice = isRgb ? 1950000 : 1760000;
            item.price = unitPrice;
            item.final_line_price = unitPrice * item.quantity;
          }
        });
        lastCartState.total_price = lastCartState.items.reduce((sum, item) => sum + (item.final_line_price || (item.price * item.quantity) || 0), 0);
      }
      renderCartDrawer(lastCartState);
    } catch (err) {
      console.warn('Shopify Cart API notice:', err);
    }
  };

  // Render Cart Items in Drawer (Queries live DOM elements at runtime)
  function renderCartDrawer(cart) {
    if (!cart) return;
    lastCartState = cart;

    const cBadges = document.querySelectorAll('.cart-count-val');
    cBadges.forEach(badge => badge.textContent = cart.item_count || 0);

    const totalCents = cart.total_price || 0;

    const cartOrigTotal = document.querySelector('.cart-original-total-val');
    if (cartOrigTotal) cartOrigTotal.textContent = formatMoney(totalCents);

    const cSubtotal = document.querySelector('.cart-subtotal-val');
    if (cSubtotal) cSubtotal.textContent = formatMoney(totalCents);

    const cartTotalBill = document.querySelector('.cart-total-bill-val');
    if (cartTotalBill) cartTotalBill.textContent = formatMoney(totalCents);

    const cBody = document.getElementById('CartDrawerBody');
    const cFooter = document.getElementById('CartDrawerFooter');
    if (!cBody) return;

    if (!cart.items || cart.items.length === 0) {
      cBody.innerHTML = `
        <div class="cart-drawer__empty" style="padding: 40px 20px; text-align: center;">
          <p style="font-size: 16px; color: #666; margin-bottom: 20px;">Your cart is currently empty.</p>
          <a href="/collections/all" class="btn btn--primary" style="display: inline-block; padding: 12px 24px;">Explore Lighting Collection ↗</a>
        </div>
      `;
      if (cFooter) {
        cFooter.classList.add('hidden');
        cFooter.style.display = 'none';
      }
      return;
    }

    if (cFooter) {
      cFooter.classList.remove('hidden');
      cFooter.style.display = 'block';
    }

    let itemsHtml = '<div class="cart-drawer__items" style="display: flex; flex-direction: column; gap: 16px;">';
    cart.items.forEach((item, index) => {
      const lineNum = index + 1;
      let variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      if (item.properties && Object.keys(item.properties).length > 0) {
        variantTitle = '';
      } else {
        if (variantTitle === 'LED') variantTitle = 'With Smart RGB Light (+PKR 1,900)';
        if (variantTitle === 'Other') variantTitle = 'Standard Warm White';
      }
      itemsHtml += `
        <div class="cart-drawer__item" data-key="${item.key}" data-line="${lineNum}" style="display: flex; gap: 14px; padding-bottom: 14px; border-bottom: 1px solid #eee; align-items: center;">
          <img src="${item.image || ''}" alt="${item.product_title || ''}" style="width: 68px; height: 68px; object-fit: cover; border-radius: 6px;">
          <div style="flex: 1;">
            <h4 style="font-size: 14px; margin: 0 0 4px; font-weight: 600; color: #1A1918; line-height: 1.3;">${item.product_title || item.title}</h4>
            ${variantTitle ? `<p style="font-size: 11px; color: #777; margin: 0 0 6px;">${variantTitle}</p>` : ''}
            ${item.properties && Object.keys(item.properties).length > 0 
              ? `<div style="margin: 0 0 6px; display: flex; flex-wrap: wrap; gap: 4px;">${Object.entries(item.properties).filter(([k,v]) => v && !k.startsWith('_')).map(([k,v]) => `<span style="display:inline-block;background:#F2EEE9;color:#444;font-size:10px;font-weight:600;padding:2px 6px;border-radius:3px;border:1px solid #E2DBD0;">${v}</span>`).join('')}</div>` 
              : ''}
            <div style="display: flex; align-items: center; gap: 10px;">
              <div style="display: inline-flex; align-items: center; border: 1px solid #D1C7BD; border-radius: 4px; background: #FAF8F5; overflow: hidden; height: 28px;">
                <button type="button" class="cart-qty-btn cart-qty-minus" onclick="window.updateCartItem('${item.key}', ${item.quantity - 1}, ${lineNum});" style="width: 26px; height: 100%; border: none; background: none; font-size: 15px; font-weight: bold; cursor: pointer; color: #1A1918; display: flex; align-items: center; justify-content: center;">−</button>
                <span style="width: 26px; text-align: center; font-size: 12px; font-weight: 700; color: #1A1918;">${item.quantity}</span>
                <button type="button" class="cart-qty-btn cart-qty-plus" onclick="window.updateCartItem('${item.key}', ${item.quantity + 1}, ${lineNum});" style="width: 26px; height: 100%; border: none; background: none; font-size: 15px; font-weight: bold; cursor: pointer; color: #1A1918; display: flex; align-items: center; justify-content: center;">+</button>
              </div>
              <button type="button" class="remove-cart-item" onclick="window.updateCartItem('${item.key}', 0, ${lineNum});" style="background: none; border: none; font-size: 11px; color: #B91C1C; cursor: pointer; text-decoration: underline; font-weight: 600; padding: 0;">Remove</button>
            </div>
          </div>
          <div style="text-align: right; flex-shrink: 0;">
            ${(() => {
              const pTitle = ((item.product_title || item.title || '')).toLowerCase();
              const isFloor = pTitle.includes('aspen') || pTitle.includes('nova');
              if (isFloor) {
                const isPro = (item.variant_title && (item.variant_title.includes('Aspen Plus') || item.variant_title.includes('Aspen Pro'))) ||
                              (item.properties && (item.properties['Size'] === 'Aspen Plus' || item.properties['Size'] === 'Aspen Pro' || item.properties['Model Size'] === 'Aspen Plus' || item.properties['Model Size'] === 'Aspen Pro')) ||
                              pTitle.includes('aspen plus') || pTitle.includes('aspen pro');
                const isDark = (item.variant_title && item.variant_title.toLowerCase().includes('dark')) ||
                               (item.properties && item.properties['Leg Finish'] && item.properties['Leg Finish'].toLowerCase().includes('dark'));
                const isRgb = (item.variant_title && (item.variant_title.includes('LED') || item.variant_title.toLowerCase().includes('rgb'))) ||
                              (item.properties && item.properties['Lighting Option'] && item.properties['Lighting Option'].toLowerCase().includes('rgb'));
                let compUnit = isPro ? 3250000 : 2200000;
                if (isPro) {
                  if (isDark && isRgb) compUnit = 3550000;
                  else if (isRgb) compUnit = 3490000;
                  else if (isDark) compUnit = 3310000;
                } else {
                  if (isDark && isRgb) compUnit = 2500000;
                  else if (isRgb) compUnit = 2440000;
                  else if (isDark) compUnit = 2260000;
                }
                const totalComp = compUnit * item.quantity;
                return `
                  <div style="font-size: 11px; color: #8C857B; text-decoration: line-through; margin-bottom: 2px;">${formatMoney(totalComp)}</div>
                  <div style="font-weight: 700; font-size: 14px; color: #1A1918;">${formatMoney(item.final_line_price)}</div>
                  <span style="display: inline-block; background: #5B1626; color: #FFFFFF; font-size: 9px; font-weight: 700; padding: 1px 5px; border-radius: 3px; letter-spacing: 0.04em; text-transform: uppercase;">20% OFF • <span class="limited-time-blink">LIMITED TIME</span></span>
                `;
              } else if (item.original_line_price && item.original_line_price > item.final_line_price) {
                return `
                  <div style="font-size: 11px; color: #8C857B; text-decoration: line-through; margin-bottom: 2px;">${formatMoney(item.original_line_price)}</div>
                  <div style="font-weight: 700; font-size: 14px; color: #1A1918;">${formatMoney(item.final_line_price)}</div>
                `;
              } else {
                return `<div style="font-weight: 700; font-size: 14px; color: #1A1918;">${formatMoney(item.final_line_price)}</div>`;
              }
            })()}
          </div>
        </div>
      `;
    });
    itemsHtml += '</div>';
    cBody.innerHTML = itemsHtml;
  }

  // Update Cart Item Quantity with Instant 0ms Optimistic UI + Background Server Sync
  window.updateCartItem = async function(key, quantity, line) {
    const qty = Math.max(0, parseInt(quantity, 10));

    // 1. Instant Optimistic UI Update (0ms latency response)
    if (lastCartState && lastCartState.items && lastCartState.items.length > 0) {
      const targetIdx = line 
        ? (parseInt(line, 10) - 1) 
        : lastCartState.items.findIndex(i => String(i.key) === String(key) || String(i.id) === String(key));

      if (targetIdx !== -1 && lastCartState.items[targetIdx]) {
        const item = lastCartState.items[targetIdx];
        const unitPrice = (item.quantity > 0) ? (item.final_line_price / item.quantity) : (item.price || 0);

        if (qty === 0) {
          lastCartState.items.splice(targetIdx, 1);
        } else {
          item.quantity = qty;
          item.final_line_price = unitPrice * qty;
        }

        lastCartState.item_count = lastCartState.items.reduce((sum, i) => sum + i.quantity, 0);
        lastCartState.total_price = lastCartState.items.reduce((sum, i) => sum + i.final_line_price, 0);

        // Instant UI Render
        renderCartDrawer(lastCartState);
      }
    }

    // 2. Background Sync with Shopify Server
    try {
      let res;
      if (line) {
        res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json', 
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
        });
      }

      if (!res || !res.ok) {
        res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json', 
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ id: String(key), quantity: qty })
        });
      }

      if (!res || !res.ok) {
        res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json', 
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ updates: { [key]: qty } })
        });
      }

      if (res && res.ok) {
        const updatedCart = await res.json();
        lastCartState = updatedCart;
        renderCartDrawer(updatedCart);
        if (window.location.pathname.includes('/cart')) {
          window.location.reload();
        }
      } else {
        const fallbackUrl = line 
          ? `/cart/change?line=${encodeURIComponent(line)}&quantity=${qty}`
          : `/cart/change?id=${encodeURIComponent(key)}&quantity=${qty}`;
        window.location.href = fallbackUrl;
      }
    } catch (err) {
      console.error('Failed to update cart:', err);
    } finally {
      if (cBody) cBody.style.opacity = '1';
    }
  };

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action*="/cart/add"], .product-info__form, #LumarvaProductForm');
    if (!form) return;

    if (e.submitter && e.submitter.classList.contains('buy-now-btn')) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof window.executeDirectBuyNow === 'function') {
        window.executeDirectBuyNow(e.submitter, e);
      } else {
        const formData = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: formData })
          .then(() => { window.location.href = '/checkout'; })
          .catch(() => { window.location.href = '/checkout'; });
      }
      return false;
    }

    // If PDP custom handler already handled this, prevent duplicate submission
    if (form.getAttribute('data-processing') === 'true') {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
    form.setAttribute('data-processing', 'true');
    setTimeout(() => form.removeAttribute('data-processing'), 1500);

    e.preventDefault();
    e.stopPropagation();

    const addBtn = form.querySelector('.add-to-cart-btn, [name="add"]');
    if (addBtn) {
      addBtn.innerHTML = '<span>ADDED ✓</span>';
      setTimeout(() => { addBtn.innerHTML = 'ADD TO CART'; }, 1200);
    }

    try {
      const variantInput = form.querySelector('input[name="id"]');
      const qtyInput = form.querySelector('input[name="quantity"]');
      let variantId = variantInput ? variantInput.value : '';
      let qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      // ⚡ 0ms Optimistic Drawer Opening & Render
      if (typeof window.optimisticAddToCart === 'function') {
        window.optimisticAddToCart({
          id: String(variantId),
          title: document.querySelector('.product-info__title, h1')?.textContent?.trim() || 'LUMARVA Lamp',
          price: 0,
          quantity: qty
        });
      } else if (typeof window.openCart === 'function') {
        window.openCart();
      }

      // Async background server sync
      let res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: String(variantId), quantity: qty }] })
      });

      if (!res.ok) {
        const formData = new FormData(form);
        await fetch('/cart/add.js', { method: 'POST', body: formData });
      }

      await fetchCart();
    } catch (err) {
      console.warn('AJAX Add to Cart fallback:', err);
      await fetchCart();
    }
  });

  document.querySelectorAll('.product-card__quick-add').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      const form = btn.closest('form');
      if (form) {
        const variantInput = form.querySelector('input[name="id"]');
        const cardTitle = form.closest('.product-card')?.querySelector('.product-card__title-text')?.textContent?.trim() || 'LUMARVA Lamp';
        if (typeof window.optimisticAddToCart === 'function' && variantInput) {
          window.optimisticAddToCart({
            id: variantInput.value,
            title: cardTitle,
            price: 0,
            quantity: 1
          });
        } else if (typeof window.openCart === 'function') {
          window.openCart();
        }

        try {
          const formData = new FormData(form);
          await fetch('/cart/add.js', { method: 'POST', body: formData });
          await fetchCart();
        } catch (err) {
          await fetchCart();
        }
      }
    });
  });

  // Handle Buy Now button click -> Add to cart & direct to default Shopify /checkout
  document.addEventListener('click', async (e) => {
    const buyBtn = e.target.closest('.buy-now-btn');
    if (!buyBtn) return;

    e.preventDefault();
    e.stopPropagation();

    // If executeDirectBuyNow function is defined on PDP, let executeDirectBuyNow handle it
    if (typeof window.executeDirectBuyNow === 'function') {
      window.executeDirectBuyNow(buyBtn);
      return;
    }

    const form = buyBtn.closest('form');
    const originalText = buyBtn.innerHTML;
    buyBtn.disabled = true;
    buyBtn.innerHTML = 'PROCEEDING TO CHECKOUT...';

    try {
      if (form) {
        const formData = new FormData(form);
        await fetch('/cart/add.js', { method: 'POST', body: formData });
      }
      window.location.href = '/checkout';
    } catch (err) {
      window.location.href = '/checkout';
    } finally {
      buyBtn.disabled = false;
      buyBtn.innerHTML = originalText;
    }
  });

  // Handle Cart Drawer & Page Checkout Buttons -> Submit form or navigate to /checkout
  document.addEventListener('click', (e) => {
    const chkBtn = e.target.closest('.cart-checkout-btn, [name="checkout"]');
    if (!chkBtn) return;

    e.preventDefault();
    e.stopPropagation();

    chkBtn.disabled = true;
    chkBtn.innerHTML = '<span>PROCEEDING TO CHECKOUT...</span>';

    const form = chkBtn.closest('form') || document.getElementById('CartDrawerForm') || document.getElementById('MainCartForm');
    if (form) {
      let chkInput = form.querySelector('input[name="checkout"]');
      if (!chkInput) {
        chkInput = document.createElement('input');
        chkInput.type = 'hidden';
        chkInput.name = 'checkout';
        chkInput.value = 'Checkout';
        form.appendChild(chkInput);
      }
      form.action = '/cart';
      form.method = 'post';
      form.submit();

      // Immediate fallback to ensure user always arrives at checkout
      setTimeout(() => {
        window.location.href = '/checkout';
      }, 350);
    } else {
      window.location.href = '/checkout';
    }
  });

  // 🚀 Instant Page Hover Prefetcher (Zero Latency Site Navigation)
  (function initSpeculativePrefetch() {
    const prefetchedUrls = new Set();
    const prefetchLink = (url) => {
      if (!url || prefetchedUrls.has(url)) return;
      if (url.startsWith('#') || url.includes('javascript:') || url.includes('/cart') || url.includes('/checkout')) return;
      try {
        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = url;
        document.head.appendChild(link);
        prefetchedUrls.add(url);
      } catch (e) {}
    };

    document.addEventListener('mouseover', (e) => {
      const a = e.target.closest('a[href^="/"], a[href^="' + window.location.origin + '"]');
      if (a && a.href) {
        prefetchLink(a.href);
      }
    }, { passive: true });

    document.addEventListener('touchstart', (e) => {
      const a = e.target.closest('a[href^="/"], a[href^="' + window.location.origin + '"]');
      if (a && a.href) {
        prefetchLink(a.href);
      }
    }, { passive: true });
  })();
